import { Button, Container, Divider, Grid, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast } from "react-toastify";
import { getGroups, deleteGroup, clearReduxDataOfCurrentComponent, clearSuccessMsg, getAllGroupsList, getModelDataDropDown } from "../../store/actions";
import FieldTable from "../FieldTable";
import { Loader } from '../loader'
import { AdvancedTable, TableSupport, FiltersUtils } from 'dsilo-ui-components';
import ConfirmationHandler from '../../components/ConfirmDialog'
import { fetchPrivilegeSupport } from '../../utility/AbilityCheck'; // Import ability function
import { setStructuredLocalStorage, getStructuredLocalStorage } from '../../utility/utils';

const useStyles = makeStyles((theme) => {
    const isNewV1Theme = theme?.isNewV1Theme
    return {
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingBottom: 10,
        },
        root: {
            width: "100%"
        },
        headerClass: {
            backgroundColor: "#cecece",
            textTransform: 'capitalize'
        },
        confirmationDialoge: {
            "& .MuiDialog-paperWidthSm": {
                height: "250px",
                width: "600px"
            }
        },
        para: {
            fontSize: "28px !important",
            fontWeight: 600,
            color: "#000"
        },
        filterButton: isNewV1Theme ? {
            background: '#3F51B5',
            color: 'white',
            '&:hover': {
                background: '#3F51B5',
                opacity: 0.9
            },
        } : {},
        footer: isNewV1Theme ? {
            display: "flex",
            justifyContent: "end"
        } : {},
        pageTitle: isNewV1Theme ? {
            padding: "15px 0 0 15px"
        } : {}
    }
});

const sharedJSON = {
    "order": "asc",
    "orderBy": null,
    "selected": [],
    "tableData": [],
    "filterTableData": [],
    // "page": 0,
    "count": 10,
    // "rowsPerPage": 10,
    "searchText": "",
    "filterList": [],
    "filterData": []
}

const tableJson = [
    {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: 'Document Type',
        sort: true,
    },
    {
        id: 'keyValueFields',
        numeric: false,
        disablePadding: false,
        label: 'Key Data Fields',
        sort: true,
    },

];



const Groups = (props) => {
    const { data, formData } = props
    const { chartData, chartUniqueId } = data
    const { document } = formData
    const isNewV1Theme = document?.appConfig?.theme?.type === "v1.1"

    const classes = useStyles()
    const [groupList, setGroupList] = useState([])
    const [state, setState] = useState({ ...sharedJSON, });
    const [searchedText, setSearchedText] = useState('');
    const [deleteConfirmState, setDeleteConfirm] = useState({
        isOpen: false,
        deleteMessage: "Are you sure you want to delete ?",
        data: null
    })
    const { successMsg } = props.formData
    const { _id: userId } = props.user
    const pageUrl = props.page?.url
    const [localStorageObject, setLocalStorageObject] = useState({})
    const [isHighlighted, setHighLighted] = useState({});
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(chartData?.pagination?.rowsPerPage || 15)
    const [highLighterIdForSelectedLineItem, setHighLighterIdForSelectedLineItem] = useState('');
    const [previlageData, setPrevilageData] = useState("")

    const [filterConditions, setFilterConditions] = useState([]) // filter array to be sent in api call
    const [selectedFilterValues, setFilterValues] = useState([]) // actual filter object
    const [externalFilterData, setExternalFilterData] = useState([]) // actual filter object
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [externalFilterValues, setExternalFilterValues] = useState(false);

    // Generate abilities based on privileges
    const [ability, setAbility] = useState(null);

    // const ability = defineAbilities(privileges, selectedDataModelID);




    useEffect(() => {
        let localStoreJson = localStorage.getItem('userSession');
        let currentUserSes, _currSessPage = 0, _currSessRPP = rowsPerPage, updatedConditions = [];

        if (localStoreJson) {
            let currentSession = JSON.parse(atob(localStoreJson));
            if (Object.keys(currentSession).length > 0) {
                if (currentSession && currentSession[userId] && currentSession[userId][pageUrl]) {
                    currentUserSes = currentSession[userId][pageUrl];
                    if (currentUserSes?.page) {
                        setPage(Number(currentUserSes?.page))
                    }
                    if (currentUserSes?.rowsPerPage) {
                        setRowsPerPage(Number(currentUserSes?.rowsPerPage))
                    }
                }
            }
        }
        const localObj = getStructuredLocalStorage(userId, props.appId, pageUrl);
        if (localObj?.filters && chartData?.externalFilter) {
            setFilterValues(localObj?.filters)
            setExternalFilterValues(localObj?.filters)
            updatedConditions = FiltersUtils.createConditions(localObj?.filters, chartData.externalFilter)
            setFilterConditions(updatedConditions)
            setPage(localObj?.page)
            setRowsPerPage(localObj?.rowsPerPage)
        }
        fetchData(localObj?.page || _currSessPage, localObj?.rowsPerPage || _currSessRPP, '', updatedConditions)
        fetchAllGroupsData();
    }, [])

    // It is for external filters
    useEffect(() => {
        if (document && props.formData.document[chartUniqueId + "_groups"]?.length) {
            let _externalFilterData = []
            const name = [], description = []
            document[chartUniqueId + "_groups"].forEach(k => {
                name.push({ label: k?.name, value: k?.name, name: 'name' })
                description.push({ label: k?.description, value: k?.description, name: 'description' })
            })
            _externalFilterData = [...[name], ...[description]];
            setExternalFilterData(_externalFilterData);
        }
    }, [document?.[chartUniqueId + "_groups"]])

    useEffect(() => {
        if (document?.[chartUniqueId + '_all_groups']?.data?.length >= 0) {
            let groupListData = document?.[chartUniqueId + '_all_groups']?.data?.map(k => ({
                id: k._id,
                name: k.name,
                description: k.description,
                members: k.members.map((m) => m.name).join(', ')
            }))
            setGroupList(groupListData)
        }
    }, [document?.[chartUniqueId + '_all_groups']])

    useEffect(() => {
        setState({ ...TableSupport.updateTableData(state) });
    }, [state.searchText, state.filterList]);

    useEffect(() => {
        if (groupList) {
            const rows = tableJson;
            // const rows = listViewTableJson;
            let keysArr = ['_id'];
            // setState({ ...TableSupport.setDatafromApi2(groupList, keysArr, state, rows) });
            setState({
                ...TableSupport.setDatafromApi2(
                    getData(groupList),
                    keysArr,
                    state,
                    getColumns()
                ),
                count: document[chartUniqueId + '_all_groups']?.total
            });
            isHighlightedTile()
        }
    }, [groupList]);

    useEffect(() => {
        return () => {
            clearCurrentChartReduxStore()
        }
    }, [])


    useEffect(() => {
        if (successMsg) {
            toast.info(successMsg)
            props.clearSuccessMsg()
            fetchData(page, rowsPerPage, searchedText || '', filterConditions)
            fetchAllGroupsData()
        }
    }, [successMsg])

    useEffect(() => {
        if (localStorage.getItem('groupSession')) {
            let groupSession = JSON.parse(atob(localStorage.getItem('groupSession')))
            if (Object.keys(groupSession).length === 0) {
                if (Object.keys(localStorageObject).length > 0) {
                    localStorage.setItem('groupSession', btoa(JSON.stringify({ [userId]: { [pageUrl]: { ...localStorageObject } } })))
                }
            } else {
                for (let [key, value] of Object.entries(groupSession)) {
                    if (key === userId) {
                        for (let [key1, value1] of Object.entries(value)) {
                            if (key1 === pageUrl) {
                                groupSession[userId][pageUrl] = { ...value1, ...localStorageObject }
                                localStorage.setItem('groupSession', btoa(JSON.stringify(groupSession)))
                            } else {
                                if (Object.keys(localStorageObject).length > 0) {
                                    groupSession[userId][pageUrl] = { ...localStorageObject }
                                    localStorage.setItem('groupSession', btoa(JSON.stringify(groupSession)))
                                }
                            }
                        }
                    }
                }
            }
        } else if (Object.keys(localStorageObject).length > 0) {
            localStorage.setItem('groupSession', btoa(JSON.stringify({ [userId]: { [pageUrl]: { ...localStorageObject } } })))
        }
    }, [localStorageObject])


    const isHighlightedTile = async () => {
        let groupSession = await localStorage.getItem('groupSession')
        if (groupSession) {
            groupSession = JSON.parse(atob(groupSession))
            let currentUserSession = groupSession && groupSession[userId]
            let currentUserSessionPage = groupSession && currentUserSession && currentUserSession[pageUrl]
            if (currentUserSessionPage?.selectedLineItem) {
                setHighLighterIdForSelectedLineItem(currentUserSessionPage?.selectedLineItem)
            }
        }
    }

    const onExternalFilterChange = (filterValues) => {
            console.log("onExternalFilterChange === filterValues", filterValues)
            let _page = 0, _rowsPerPage = rowsPerPage || chartData?.pagination?.rowsPerPage || 10;
            setPage(_page)
            setRowsPerPage(_rowsPerPage)
    
            let updatedConditions = FiltersUtils.createConditions(filterValues, chartData.externalFilter)
            setFilterConditions(updatedConditions)
            setFilterValues(filterValues)
            setExternalFilterValues(filterValues)
    
            setStructuredLocalStorage(
                userId,
                props.appId,
                pageUrl,
                { 'filters': filterValues, 'page': _page, 'rowsPerPage': _rowsPerPage }
            );
    
            fetchData(_page, _rowsPerPage, '', updatedConditions)
        }


    const getData = (dataSource) => {
        const clonedDataSource = JSON.parse(JSON.stringify(dataSource))
        let fetchType;
        return clonedDataSource.map((item) => {
            const keys = Object.keys(item)
            keys.forEach((key) => {
                if (key && typeof item[key] !== "string") {
                    if (fetchType === "keysArray" && !selectedInnerSupportDataElement) {
                        if (data?.chartData?.selectedInnerDataElement?.length) {
                            data?.chartData?.selectedInnerDataElement?.map(side => {
                                if (side.value === key) {
                                    if (side.type === "namepicker") {
                                        if (item[key] instanceof Array) {
                                            item[key] = item[key].map(obj => obj.label).join(', ')
                                        } else {
                                            item[key] = item[key]
                                                ? (typeof item[key] === "object"
                                                    ? item[key][label]
                                                    : item[key])
                                                : ""
                                        }
                                    } else {
                                        item[key] = item[key] || item[key] === 0 ? JSON.stringify(item[key]) : ""
                                    }
                                }
                            })
                        } else {
                            item[key] = item[key] || item[key] === 0 ? JSON.stringify(item[key]) : ""
                        }
                    } else {
                        if (data.chartData?.selectedDataElement?.length) {
                            data.chartData?.selectedDataElement?.map(sde => {
                                if (sde.value === key) {
                                    if (sde.type === "namepicker") {
                                        if (item[key] instanceof Array) {
                                            item[key] = item[key].map(obj => obj.label).join(', ')
                                        } else {
                                            item[key] = item[key]
                                                ? (typeof item[key] === "object"
                                                    ? item[key][label]
                                                    : item[key])
                                                : ""
                                        }
                                    } else {
                                        item[key] = item[key] || item[key] === 0 ? JSON.stringify(item[key]) : ""
                                    }
                                }
                            })
                        } else {
                            item[key] = item[key] || item[key] === 0 ? JSON.stringify(item[key]) : ""
                        }
                    }
                    // item[key] = item[key] || item[key] === 0 ? JSON.stringify(item[key]) : ""
                }
            })
            return item
        })
    }

    const getColumns = () => {
        console.log('groupList?.length', groupList?.length, groupList);
        let COLUMNS = []
        if (groupList?.length > 0) {
            COLUMNS = Object.keys(
                groupList[0]
            ).map((i) => {
                return {
                    id: i,
                    name: i,
                    numeric: false,
                    disablePadding: false,
                    label: i,
                    sort: true,
                    checked: true
                }
            }).filter(i => i.id !== 'id')
        } else {
            COLUMNS = chartData?.selectedDataElement?.map((i) => {
                return {
                    id: i?.value,
                    name: i?.value,
                    numeric: false,
                    disablePadding: false,
                    label: i?.label,
                    sort: true,
                    checked: true
                }
            })
        }
        return COLUMNS
    }

    const fetchData = (_page = page, _rowsPerPage = rowsPerPage, _searchText = '', _conditions = []) => {
        props.getAllGroupsList({
            appId: props?.appId,
            dataUniqueId: chartUniqueId + '_all_groups',
            payload: {
                page: _page,
                rowsPerPage: _rowsPerPage,
                ...(_searchText && { search: _searchText }),
                ...(state.order &&
                    state.orderBy && {
                    sort: state.order,
                    sortBy: state.orderBy,
                }),
                ...(_conditions && _conditions.length && {
                    conditions: _conditions
                })
            },
        })
    }

    const fetchAllGroupsData = () => {
        props.getGroups({
            appId: props.appId,
            orgId: props?.user?.orgId,
            dataUniqueId: chartUniqueId + '_groups',
        });
    }

    const onRowClick = (rowData, rowMeta) => {
        console.log('onRowClick');
    };

    const onSearchEnter = (e, onSearchButton = false) => {
        if (e === null) {
            setPage(0)
            fetchData(0, rowsPerPage, '', filterConditions)
            searchHandler(null)
        } else if (e?.keyCode === 13 || onSearchButton) {
            setPage(0)
            fetchData(0, rowsPerPage, searchedText, filterConditions)
        }
    }

    const handleChangePage = (event, page) => {
        fetchData(page, rowsPerPage, searchedText || '', filterConditions)
        setPage(page)
        setLocalStorageObject({ ...localStorageObject, page: page })
    };

    const onAddClick = () => {
        props.history.push({ pathname: `/${props.match.params.appid}/page/group/new` });
    }

    const handleChangeRowsPerPage = event => {
        fetchData(0, event.target.value, searchedText || '', filterConditions)
        setRowsPerPage(event.target.value)
        setPage(0)
        setLocalStorageObject({ ...localStorageObject, rowsPerPage: event.target.value, page: 0 })
    };

    const searchHandler = (e) => {
        setSearchedText(e ? e.target.value : "")
    }

    const handleInputChange = event => {
        let obj = state.filterTableData;
        let list = obj.columns;
        list.map((item, index) => {
            if (item.name === event.target.value) list[index].checked = event.target.checked;
        });
        obj.columns = [...list];
        setState({ ...state, filterTableData: obj });
        setState({ ...TableSupport.updateTableData(state) });
    };

    const resetFilters = event => {
        setState({ ...state, filterList: [] });
    };

    const handleDropdownChange = (event, index, column) => {
        const value = event.target.value === 'All' ? [] : [event.target.value];
        // filterUpdate(index, value, column, 'dropdown');
        let list = state.filterList;
        list[index] = event.target.value;
        setState({ ...state, filterList: [...list] });
        setState({ ...TableSupport.updateTableData(state) });
    };

    const handleRequestSort = (event, property) => {
        let obj = TableSupport.requestSort(event, property, state);
        setState({ ...state, ...obj });
    };

    const handleSelectAllClick = event => {
        setState({
            ...state,
            selected: TableSupport.handleTableSelectAllClick(event, state.filterTableData.datasets),
        });
    };

    const tableCrudOperations = (item, type) => {
        if (type === 'edit') {
            onClickAnyAction(item.id)
            props.history.push({
                pathname: `/${props.match.params.appid}/page/${chartData.editPage}/${item.id}`,
            })
        }
        if (type === 'delete') {
            setDeleteConfirm({
                ...deleteConfirmState,
                isOpen: true,
                data: item.id
            })
        }

    };

    const onDeleteResponse = (isDelete) => {
        if (isDelete) {
            const payload = {
                appid: props.appId,
                dataUniqueId: props.data?.chartUniqueId + '_delete_group',
                orgId: props.user?.orgId,
                id: deleteConfirmState.data
            }
            props.deleteGroup(payload)
        }
        setDeleteConfirm({ ...deleteConfirmState, isOpen: false, data: null })
    }

    const handleCheck = (event, id) => {
        const { selected } = state;
        let newSelected = TableSupport.handleSelectedRow(event, id, selected);
        setState({ ...state, selected: newSelected });
        props.checkedContractChanged(newSelected);
    };

    const onClickAnyAction = (docId) => {
        const { _id: userId } = props.user
        if (localStorage.getItem('userSession')) {
            let userSession = JSON.parse(atob(localStorage.getItem('userSession')))
            for (let [key, value] of Object.entries(userSession)) {
                if (key === userId) { // userId matched
                    for (let [key1, value1] of Object.entries(value)) {
                        if (key1 === pageUrl) { // page matched
                            userSession[userId][pageUrl] = { ...value1, 'selectedLineItem': docId }
                            localStorage.setItem('userSession', btoa(JSON.stringify(userSession)))
                        } else {
                            if (Object.keys(userSession).length > 0) {
                                userSession[userId][pageUrl] = { ...value1, 'selectedLineItem': docId }
                                localStorage.setItem('userSession', btoa(JSON.stringify(userSession)))
                            }
                        }
                    }
                }
            }
        } else {
            localStorage.setItem('userSession', btoa(JSON.stringify({ [userId]: { [pageUrl]: { 'selectedLineItem': docId } } })))
        }
    }

    const clearCurrentChartReduxStore = () => {
        let subKeys = [
            props.data?.chartUniqueId + '_all_groups',
            props.data?.chartUniqueId + '_create_group'
        ]

        props.clearReduxDataOfCurrentComponent({
            key: "document",
            subKey: subKeys
        })
    }

    // Member Privileges code end here
    useEffect(() => {
        const { privilegeData, ability } = fetchPrivilegeSupport(props, chartData);
        setPrevilageData(privilegeData);
        setAbility(ability);
    }, [
        props.formData.document[`${props.match.params.appid}_memberprivileges`],
        props?.privilegesSupport,
        props.match.params.page,
        window.location.pathname,
        chartData?.selectedDataModel
    ]);
    // Member Privileges code end here

    const handleFilterClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleFilterClose = (type) => {
        switch (type) {
            case 'save':
                setAnchorEl(null);
                // onExternalFilterChange(externalFilterValues)
                // setFilterValues(externalFilterValues)
                break;
            case 'close':
                setAnchorEl(null);
                break;
            case 'clearAll':
                for (let vals in externalFilterValues) {
                    externalFilterValues[vals] = null;
                }
                onExternalFilterChange(externalFilterValues)
                setFilterValues(externalFilterValues)
                break;
        }
    };

    return (
        <>
            <AdvancedTable
                    name={'GroupsList'}
                    onRowClick={onRowClick}
                    {...props}
                    {...state}
                    chartData={chartData}

                    // External filters
                    resetFilters={resetFilters}
                    externalFilters={chartData?.externalFilter}
                    externalFilterData={externalFilterData}
                    externalFilterValues={selectedFilterValues}
                    onExternalFilterChange={onExternalFilterChange}

                    searchedText={searchedText}
                    searchHandler={searchHandler}
                    onSearchEnter={onSearchEnter}
                    isExport={false}
                    isViewCoulmns={false}
                    isSearch={chartData?.isSearch || false}
                    isLoading={props.formData[chartUniqueId + '_all_groups_loading']}
                    isFilter={false}
                    hasCheckbox={false}
                    actions={{ edit: true, view: false, delete: true, copy: false, download: false }}
                    isTablePagination={true}
                    pagination={chartData?.pagination}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isTableHead={true}
                    isTableSubHeader={false}
                    associatedFormName={chartData.associatedFormName}
                    handleInputChange={handleInputChange}
                    onAddClick={onAddClick}
                    handleDropdownChange={handleDropdownChange}
                    handleRequestSort={handleRequestSort}
                    handleSelectAllClick={handleSelectAllClick}
                    tableCrudOperations={tableCrudOperations}
                    handleCheck={handleCheck}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    headerstyle={{
                        fontSize: "14px",
                        color: "rgba(0, 0, 0, 0.87)",
                        textAlign: "left",
                        backgroundColor: "#"
                    }}
                    subHeaderstyle={{
                        fontSize: "14px",
                        color: "rgba(0, 0, 0, 0.87)",
                        backgroundColor: "#FFF",
                        textAlign: "left"
                    }}
                    headerClass={classes.headerClass}
                    rowStyle={{
                        fontSize: "14px",
                        color: "rgba(0, 0, 0, 0.87)",
                        backgroundColor: "none",
                        lineHeight: 1.5,
                        textAlign: "left"
                    }}
                    stripRows
                    loader={<Loader />}
                    isNestedTable={props.isNestedTable}
                    onExapandIconClick={props.onExapandIconClick}
                    nestedTableData={props.nestedTableData}
                    highLighterIdForSelectedLineItem={highLighterIdForSelectedLineItem}
                    previlageData={previlageData}
                    ability={ability}
                    isNewV1Theme={isNewV1Theme}
                    anchorEl={anchorEl}
                    setAnchorEl={setAnchorEl}
                    handleFilterClose={handleFilterClose}
                    handleFilterClick={handleFilterClick}
                    setExternalFilterValues={setExternalFilterValues}
                    title={props.page?.title}
                    classes={classes}

                    // Pagination
                    paginationPage={page}
                />
            <ConfirmationHandler
                open={deleteConfirmState.isOpen}
                handleClose={onDeleteResponse}
                alertMessageText={deleteConfirmState.deleteMessage}
                classes={classes}
                confirm
            />
        </>
    )
}

const mapDispatchToProps = {
    getGroups,
    getAllGroupsList,
    getModelDataDropDown,
    deleteGroup,
    clearReduxDataOfCurrentComponent,
    clearSuccessMsg
};

const mapStateToProps = state => {
    return {
        formData: state.form,
        org: state.org,
        member: state.appConfig.members,
        user: state.user,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Groups));